import React from "react";
import { Link } from "react-router-dom";

const PhilosophySection = () => {
  return (
    <section
      id="philosophy"
      className="bg-black py-20 md:py-32"
      aria-labelledby="philosophy-heading"
    >
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">

          {/* Image Side */}
          <div className="relative order-2 md:order-1">
            <img
              src="https://i.imgur.com/vZdfmwT.jpeg"
              alt="Boxing training and fitness at Bond Boxing Gym in Gaborone"
              width="1200"
              height="1500"
              loading="lazy"
              decoding="async"
              className="w-full h-[500px] object-cover shadow-2xl"
            />

            <div className="absolute -top-6 -left-6 w-24 h-24 border-t-4 border-l-4 border-red-600"></div>

            <div className="absolute -bottom-6 -right-6 w-24 h-24 border-b-4 border-r-4 border-red-600"></div>
          </div>

          {/* Content Side */}
          <div className="order-1 md:order-2">

            <div
              className="text-red-600 text-6xl font-bold mb-6"
              aria-hidden="true"
            >
              01
            </div>

            <p className="text-red-500 text-xl font-semibold mb-4 tracking-wider">
              Mission &amp; Vision
            </p>

            <h2
              id="philosophy-heading"
              className="text-white text-5xl md:text-6xl font-bold mb-8 leading-tight"
            >
              Discipline
              <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">
                Over Everything.
              </span>
            </h2>

            <p className="text-gray-400 text-lg leading-relaxed mb-6">
              At Bond Boxing, our mission is to develop champions through
              boxing, fight experiences and inclusive fitness. We believe
              discipline, dedication and community are the foundations of
              personal growth, both inside and outside the ring.
            </p>

            <p className="text-gray-400 text-lg leading-relaxed mb-8">
              Based in Gaborone, Botswana, Bond Boxing is committed to
              creating opportunities for individuals to develop their
              boxing abilities, improve their fitness and become part of
              a community built around discipline and excellence.
            </p>

            <Link
              to="/contact"
              className="inline-block bg-red-600 hover:bg-red-700 text-white px-8 py-4 font-semibold tracking-wide transition-all duration-300 border border-red-600 hover:border-red-700 hover:shadow-lg hover:shadow-red-600/50 hover:scale-105"
            >
              Join The Ranks
            </Link>

          </div>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;